// 필드 내용 관련 노션 (https://www.notion.so/barogohq/goodsPayRestrictType-6a50610cb3a04690846a83e3d35a5243?pvs=4)
import { i18n } from '@/locales';
const lc = 'views.store_management_detail.goods_pay_restrict_type_options.';
export default {
    // “선결제 + 카드 +현금”
    NONE: {
        value: [
            'prepaid',
            'card-paid',
            'cash',
        ],
        text: i18n.t(`${lc}none`),
        key: 'NONE',
    },
    // “선결제 + 카드”
    PREPAYMENT_AND_CARD: {
        value: [
            'prepaid',
            'card-paid',
        ],
        text: i18n.t(`${lc}prepayment_and_card`),
        key: 'PREPAYMENT_AND_CARD',
    },
    // “선결제”
    PREPAYMENT: {
        value: [
            'prepaid',
        ],
        text: i18n.t(`${lc}prepayment`),
        key: 'PREPAYMENT',
    },
};
